import { GetOrderSummaryResponseData } from "types/api/orders/getOrderSummary.ts";

export const InitialFilterOptions = {
	accounts: [],
	designers: [],
	brands: [],
	status: [],
	types: [],
	hasStatusTriggered: false,
	isStockOrders: false
};

export const InitialDraftFilterOptions = {
	accounts: [],
	designers: [],
	brands: [],
	status: [],
	types: [],
	hasStatusTriggered: false
};

export const InitialOpenLeadFilterOptions = {
	assignedToLocation: [],
	assignedToPerson: [],
	status: [],
	brands: []
};

export const InitialClosedLeadFilterOptions = {
	assignedToLocation: [],
	assignedToPerson: [],
	status: [],
	brands: []
};

export const InitialUnassignedLeadFilterOptions = {
	assignedToLocation: [],
	assignedToPerson: [],
	status: [],
	brands: []
};

export const InitialLeadDateFilterOption = "all";

export const InitialDraftQuoteFilterOptions = {
	accounts: [],
	brands: [],
	hasStatusTriggered: false
};

export const InitialQuoteFilterOptions = {
	designers: [],
	productLines: [],
	status: [],
	hasStatusTriggered: false
};

export const InitialSearchDates = {
	fromDate: undefined,
	toDate: undefined
};

export enum CacheKeys {
	Filters = "_cabinet_filters",
	DraftFilters = "_cabinet_draft_filters",
	NewOrderQuoteDraftFilters = "_cabinet_new_order_quote_draft_filters",
	TemplateFilters = "_cabinet_template_filters",
	QuoteFilters = "_cabinet_quote_filters",
	Partial = "_cabinet_partial",
	Search = "_cabinet_search",
	Dates = "_cabinet_dates",
	Orders = "_cabinet_orders",
	OpenLeadFilters = "_cabinet_open_lead_filters",
	ClosedLeadFilters = "_cabinet_closed_lead_filters",
	UnassignedLeadFilters = "_cabinet_unassigned_lead_filters",
	OpenLeadDateFilter = "_cabinet_open_lead_date_filter",
	ClosedLeadDateFilter = "_cabinet_closed_lead_date_filter",
	UnassignedLeadDateFilter = "_cabinet_unassigned_lead_date_filter"
}

export const InitialOrderResponse: GetOrderSummaryResponseData = {
	isPartialDataset: false,
	items: []
};
